module.exports = __webpack_public_path__ + "static/media/product.f616543a.svg";